import { Text } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeTitleProps } from './types';

/**
 * El slot tipográfico (text-headline-h1 por defecto) lo decide el caller
 * a través de `typographyClass` — así un Estilo del catálogo
 * (`text-style-{slug}`) puede reemplazarlo limpiamente sin pelearse con
 * un className hardcodeado.
 */
export const Title: FunctionComponent<TypeTitleProps> = ({
  children,
  className = '',
  as = 'p',
  typographyClass = 'text-headline-h1',
}: TypeTitleProps) => (
  <Text
    as={as}
    className={`md:text-display text-headline ${typographyClass} text-neutrals-0 mb-6 w-full md:w-[590px] ${className}`}
  >
    {children}
  </Text>
);
